/* unplugin-vue-components disabled */import script from "./user-bind-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./user-bind-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./user-bind-dialog.vue?vue&type=style&index=0&id=dec2deca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dec2deca"]])

export default __exports__